import request from '@/utils/request.js';

const prefix = 'https://eapi.parapack.net/';

export async function getConsoleData(params) {
    const url = prefix + 'web/data';

    return request.get({ url });
}